import React, { FC, useCallback } from 'react';
import classNames from 'classnames';

import Button from 'vibo-ui/Button';
import SettingsItem from './SettingsItem';
import Icon, { IconmoonFont } from 'vibo-ui/Icon';

import { useModal } from 'vibo-ui/Modal';

import { DROP_SESSIONS } from 'graphql/mutations/user';
import { GET_USER_SESSIONS } from 'graphql/queries/user';

import { Modals } from 'types/enums';

import useStyles from './style';

const SessionsManagement: FC = () => {
  const classes = useStyles();

  const { openModal } = useModal();

  const openSessionsModal = useCallback(
    () =>
      openModal({
        key: Modals.sessions,
        props: {
          sessionsQuery: GET_USER_SESSIONS,
          dropSessionMutation: DROP_SESSIONS,
        },
      }),
    []
  );

  return (
    <SettingsItem>
      <div className={classNames('label', classes.label)}>
        <Icon icon={IconmoonFont['sessionManagement-24']} className={classes.generalIcon} />
        <Button onClick={openSessionsModal} displayType="link">
          Session management
        </Button>
      </div>
    </SettingsItem>
  );
};

export default SessionsManagement;
